import React, { useRef, useEffect } from 'react';

import { $ } from 'base/bootstrap';

export default function InfoCircleTooltip({ content }: Readonly<{ content: string }>) {
    const anchor = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        $(anchor.current).tooltip();
    }, []);

    return (
        <span data-toggle="tooltip" ref={anchor} title="" data-original-title={content}>
            <i className="fas fa-info-circle text-primary" />
        </span>
    );
}
